<template>
    <header class="pc-header">
        <button type="button" class="pc-search" @click="$store.dispatch('user/setIsShowSearchPopup', true)"><UiIcon name="search" /><span>{{ pcCopy.search }}</span></button>
        <div class="pc-header-actions">
            <router-link class="pc-help" to="/notification?type=0" :aria-label="pcCopy.help"><UiIcon name="headset" /></router-link>
            <template v-if="!isLogin">
                <button type="button" class="pc-button secondary" @click="login(2)">{{ pcCopy.login }}</button>
                <button type="button" class="pc-button primary" @click="login(1)">{{ pcCopy.register }}</button>
            </template>
            <template v-else>
                <router-link class="pc-button secondary pc-profile-link" to="/PersonBox"><UiIcon name="profile" /><span>{{ $t('tabbar.Account') }}</span></router-link>
                <button type="button" class="pc-button primary" @click="onNavToByIsLogin({ url: '/wallet', type: 'get', params: { type: 'deposit' } })">{{ $t('deposit.Deposit') }}</button>
            </template>
        </div>
    </header>
</template>

<script>
import UiIcon from './UiIcon.vue'
import desktopCopy from './copy'
export default {
    components: { UiIcon },
    mixins: [desktopCopy],
    computed: { isLogin() { return !!this.$store.getters.token } },
    methods: {
        login(type) {
            this.$store.dispatch('user/changeLoginType', type)
            this.$store.dispatch('user/setIsShowLoginPopup', true)
        }
    }
}
</script>

<style scoped>
.pc-header { height: 88px; display: flex; align-items: center; justify-content: space-between; gap: 24px; padding: 18px 20px 18px 26px; background: #121418; }
.pc-search { height: 52px; width: min(48%, 600px); display: flex; align-items: center; gap: 20px; padding: 0 20px; border: 1px solid #34343a; border-radius: 11px; background: #1b1d23; color: #bfc0ce; font-size: 16px; text-align: left; cursor: pointer; }
.pc-search .pc-icon { color: #f7f6f5; }
.pc-header-actions { display: flex; align-items: center; gap: 16px; }
.pc-help { display: grid; place-items: center; width: 42px; height: 48px; color: #f7f6f5; }
.pc-help .pc-icon { width: 30px; height: 30px; }
.pc-button { height: 50px; display: inline-flex; align-items: center; justify-content: center; gap: 10px; padding: 0 22px; border: 1px solid #34343a; border-radius: 10px; font-size: 16px; font-weight: 500; cursor: pointer; color: #f7f6f5; text-decoration: none; }
.pc-button.secondary { background: #1b1d23; }
.pc-button.primary { background: #ff6055; border-color: #ff6055; }
.pc-button:hover { filter: brightness(1.1); }
@media (max-width: 1199px) { .pc-header { padding-inline: 20px; gap: 16px; } .pc-header-actions { gap: 10px; } .pc-button { padding-inline: 16px; } }
</style>
